export default {
    props: {
        steps: { type: Array, default: []},
        current: {type: Number, default: 0 }
    },
    render(createElement) {
        return (this.steps.length > 0) ? this.steps[this.current -1] : null
    }
}